import React from 'react';
import { i18n as I18n } from 'utils/i18n';
import Textbox from '../../textbox';

const TownField = ({ error, ...props }) => {
  return (
    <Textbox
      label={I18n.t('registration.company_details.fields.town.label')}
      name="town"
      placeholder={I18n.t('registration.company_details.fields.town.label')}
      error={!!error}
      errorMsg={error}
      className="input--town"
      {...props}
    />
  );
};

export default TownField;
